import { useState } from "react";
import API_BASE_URL from "../config";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import Button from "@mui/material/Button"; // ✅ MUI Button importálása

const ChangePasswordPage = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();
  const { darkMode } = useTheme();

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
  
    if (!currentPassword.trim()) {
      setError("Introduceți parola actuală.");
      return;
    }
    if (!newPassword.trim()) {
      setError("Introduceți parola nouă.");
      return;
    }
    if (!confirmNewPassword.trim()) {
      setError("Confirmați parola nouă.");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      setError("Parolele noi nu sunt identice.");
      return;
    }
  
    try {
      const token = localStorage.getItem("token");
  
      const response = await fetch(`${API_BASE_URL}/api/users/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ currentPassword, newPassword }),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        console.log("🔴 API válasz:", data); // 🔥 Debugging
  
        if (data.errors?.NewPassword?.length > 0) {
          setTimeout(() => setError("Parola nouă trebuie să aibă cel puțin 6 caractere."), 100);
          return;
        }
  
        if (data.message === "Parola actuală este incorectă.") {
          setTimeout(() => setError("Parola actuală este incorectă."), 100);
          return;
        }
  
        setTimeout(() => setError(data.message || "Eroare la schimbarea parolei."), 100);
        return;
      }
  
      setSuccess("Parola a fost schimbată cu succes! Vei fi delogat automat.");
  
      // 🔥 2 másodperc után kijelentkezteti a felhasználót
      setTimeout(() => {
        localStorage.removeItem("token"); // Token törlése
        navigate("/"); // Átirányítás a bejelentkezési oldalra
        window.location.reload(); // Az oldal újratöltése, hogy frissüljön az állapot
      }, 2000);
    } catch (err) {
      setTimeout(() => setError(err.message), 100);
    }
  };
  
  return (
    <div
      className={`flex items-center justify-center h-[100%] ${
        darkMode ? "bg-gray-900" : "bg-gray-200"
      }`}
    >
      <div
        className={`p-6 rounded-lg shadow-lg max-w-md w-full ${
          darkMode ? "bg-gray-800 text-white" : "bg-white text-gray-900"
        }`}
      >
        <h2
          className={`text-2xl font-bold text-center mb-4 ${
            darkMode ? "text-white" : "text-gray-900"
          }`}
        >
          Schimbare parolă
        </h2>

        {error && <p className="text-red-500 text-lg text-center py-6">{error}</p>}
        {success && (
          <p className="text-green-500 text-lg text-center">{success}</p>
        )}

        <form onSubmit={handleChangePassword} className="space-y-4">
          <div>
            <label
              className={`block font-medium ${
                darkMode ? "text-gray-300" : "text-gray-700"
              }`}
            >
              Parola actuală:
            </label>
            <input
              type="password"
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 
                ${
                  darkMode
                    ? "bg-gray-700 text-white border-gray-600"
                    : "bg-white text-gray-900 border-gray-300"
                }`}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </div>
          <div>
            <label
              className={`block font-medium ${
                darkMode ? "text-gray-300" : "text-gray-700"
              }`}
            >
              Parolă nouă:
            </label>
            <input
              type="password"
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 
                ${
                  darkMode
                    ? "bg-gray-700 text-white border-gray-600"
                    : "bg-white text-gray-900 border-gray-300"
                }`}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div>
            <label
              className={`block font-medium ${
                darkMode ? "text-gray-300" : "text-gray-700"
              }`}
            >
              Confirmă parola nouă:
            </label>
            <input
              type="password"
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 
                ${
                  darkMode
                    ? "bg-gray-700 text-white border-gray-600"
                    : "bg-white text-gray-900 border-gray-300"
                }`}
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
            />
          </div>
          {/* 🔥 Gomb dizájnja a kép szerint */}
          <Button
            type="submit"
            fullWidth
            variant="outlined" // 🔹 Keretes gomb
            sx={{
              fontSize: "20px",
              fontWeight: "bold",
              borderRadius: "8px",
              paddingY: "10px",
              textTransform: "none",
              borderColor: "#FF5252", // Piros keret
              color: "#FF5252", // Piros szöveg
              backgroundColor: "transparent", // Háttér nélkül
              "&:hover": {
                backgroundColor: "rgba(255, 82, 82, 0.1)", // Halvány piros háttér hoverkor
              },
            }}
          >
            Schimbă parola
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
